import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getPlans = (planType,setLoading) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) {
        setLoading(true);
    }
    const res = await api("get", `${Constants.END_POINT.PLANS}?planType=${planType}`);
    
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.PLANS,
                payload: res.data,
            });
        }
    }
    if (setLoading) {
        setLoading(false);
    }
    dispatch(hideLoaderAction());
};
const purchasePlan = (payload, setLoading) => async (dispatch) => {
    dispatch(showLoaderAction());
     if (setLoading) {
        setLoading(true);
    }

    const res = await api("post", Constants.END_POINT.SUBSCRIPTION_PLAN, payload);
    if (res.success) {
        console.log("res-------------------->",res);
        
        dispatch(showToast({ severity: "success", summary: res.message }));
        // next(res.data);
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    setLoading(false);
    dispatch(hideLoaderAction());
};
export { getPlans,purchasePlan};
